import { createAction, createReducer } from 'redux-act';



/**
 * Reducer and action used to check if we have to use the search parameters given in the URL.
 * These parameters must be handled only for the first navigation to the PLC choice page.
 */
export const removeHandleDefaultSearchParameters = createAction('REMOVE_HANDLE_DEFAULT_SEARCH_PARAMETERS');
const DEFAULT_HANDLE_DEFAULT_SEARCH_PARAMETERS = true;
export const shouldHandleDefaultSearchParameters = createReducer(function (on, off) {
  on(removeHandleDefaultSearchParameters, (state, payload) => { return false; });
}, DEFAULT_HANDLE_DEFAULT_SEARCH_PARAMETERS);
